var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgIconStatusUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "15px",
    viewBox: "0 0 10 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Up",
    transform: "translate(1, 1)",
    stroke: "#323232",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrow",
    transform: "translate(0, 9)",
    opacity: 0.301547096
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "0 0 4.00000002 4.00000002 8.00000003 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(4, 2) scale(1, -1) translate(-4, -2)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "0 0 4.00000002 4.00000002 8.00000003 0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusUp);
export default __webpack_public_path__ + "static/media/icon-status-up.fb386b5da6f50e9f7863fd59840382a2.svg";
export { ForwardRef as ReactComponent };